const wordSeparatorCharPattern = /[\s\|\-]/;
function getNWords(str, numWordsToCount) {
    let wordCount = numWordsToCount;
    let i = 0;
    while (i < str.length && wordCount > 0) {
        while (i < str.length && str[i].match(wordSeparatorCharPattern)) {
            i++;
        }
        while (i < str.length && !str[i].match(wordSeparatorCharPattern)) {
            i++;
        }
        wordCount--;
    }
    const value = str.substring(0, i);
    return {
        value,
        actualWordCount: numWordsToCount - wordCount,
        isFullString: i >= str.length
    };
}
function countWords(str) {
    const result = getNWords(str, Number.MAX_SAFE_INTEGER);
    return result.actualWordCount;
}
export { countWords, getNWords };
